/** Prefix of a page icon that is an uploaded image (an attachment), e.g. `img:logo.png`. */
export const IMAGE_ICON = 'img:';

export const isImageIcon = (icon: string | null | undefined) => !!icon?.startsWith(IMAGE_ICON);
